import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FiArrowLeft, FiAlertCircle, FiClock, FiFileText } from 'react-icons/fi';
import ApiServices from '../services/apiservices';

const MeterPriceView = () => {
  const { postLinkTitle } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        setLoading(true);
    
        const response = await ApiServices.getRequest(
          `/meter-prices/fetch.php?postLinkTitle=${postLinkTitle}`
        );
    
        console.log("API Response:", response);
        console.log("Route Param:", postLinkTitle);
    
        if (response?.success) {
          const posts = Array.isArray(response.posts)
            ? response.posts
            : response.post
            ? [response.post]
            : [];
    
          console.log("Posts:", posts);
    
          const selectedPost =
            posts.find(
              (item) =>
                item.postLinkTitle?.trim().toLowerCase() ===
                postLinkTitle?.trim().toLowerCase()
            ) || posts[0];
    
          console.log("Selected Post:", selectedPost);
    
          if (selectedPost) {
            if (typeof selectedPost.rows === "string") {
              try {
                selectedPost.rows = JSON.parse(selectedPost.rows);
              } catch (e) {
                console.log("Rows JSON Parse Error:", e);
              }
            }
    
            console.log("Rows:", selectedPost.rows);
    
            setPost(selectedPost);
          } else {
            setPost(null);
          }
        } else {
          setPost(null);
        }
      } catch (error) {
        console.error(error);
        setPost(null);
      } finally {
        setLoading(false);
      }
    };
    fetchPost();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [postLinkTitle]);

  if (loading) {
    return (
      <div className="w-full min-h-screen bg-white flex items-center justify-center p-4">
        <div className="text-center">
          <div className="w-12 h-12 md:w-16 md:h-16 border-4 border-green-700 border-t-yellow-400 rounded-full animate-spin mx-auto mb-6"></div>
          <p className="text-xs md:text-sm font-black uppercase tracking-widest text-gray-400">Loading price schedule...</p>
        </div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="w-full min-h-screen bg-white flex items-center justify-center p-4 sm:p-6">
        <div className="max-w-md w-full bg-gray-50 p-6 md:p-12 rounded-[2rem] md:rounded-[3rem] border border-gray-100 text-center shadow-xl">
          <div className="bg-red-50 w-16 h-16 md:w-20 md:h-20 rounded-2xl md:rounded-3xl flex items-center justify-center mx-auto mb-6 md:mb-8 shadow-sm">
            <FiAlertCircle className="text-red-500 text-3xl md:text-4xl" />
          </div>
          <h2 className="text-xl md:text-2xl font-black text-black uppercase tracking-tight mb-3 md:mb-4">Post Not Found</h2>
          <p className="text-sm md:text-base text-gray-500 font-medium mb-8 md:mb-10 leading-relaxed">The meter price information you are looking for may have been moved or archived.</p>
          <button
            onClick={() => window.history.back()}
            className="w-full bg-black text-white py-4 md:py-5 rounded-xl md:rounded-2xl font-black uppercase tracking-widest text-xs hover:bg-green-700 transition-all shadow-xl"
          >
            ← Return to List
          </button>
        </div>
      </div>
    );
  }

  const allRows = post.rows || [];
  
  // Header keys determined from the rows array
  const tableHeaders =
    allRows.length > 1
      ? Object.keys(allRows[1])
      : allRows[0]
        ? Object.keys(allRows[0])
        : [];

  const displayRows = allRows.slice(1);

  return (
    <div className="w-full min-h-screen bg-white font-sans">
      {/* Header Section */}
      <div className="bg-[#14532d] border-b border-gray-100 py-12 md:py-24 overflow-hidden">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <button
            onClick={() => window.history.back()}
            className="flex items-center gap-2 text-xs font-black uppercase tracking-widest text-white/60 hover:text-yellow-400 mb-6 md:mb-8 transition-colors"
          >
            <FiArrowLeft /> Back to Prices
          </button>
          <h1 className="text-2xl md:text-5xl lg:text-7xl font-black text-white uppercase tracking-tighter mb-4 md:mb-6 leading-tight max-w-4xl break-words">
            {post.title}
          </h1>
          <div className="w-16 md:w-24 h-1.5 md:h-2 bg-yellow-400 rounded-full mb-6 md:mb-8"></div>

          <div className="flex flex-wrap items-center gap-4 md:gap-8 text-white/60 font-black uppercase text-[9px] md:text-[10px] tracking-widest">
            <div className="flex items-center gap-2">
              <FiClock size={14} className="text-yellow-400 flex-shrink-0" />
              {post.createdAt?.slice(0, 10)}
            </div>
            <div className="flex items-center gap-2">
              <FiFileText size={14} className="text-yellow-400 flex-shrink-0" />
              MAP Price Schedule
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12 md:py-20 lg:px-16">
        <div className="bg-white rounded-[2rem] md:rounded-[3rem] shadow-2xl border border-gray-100 overflow-hidden">
          <div className="p-5 sm:p-8 md:p-16">
            <div className="mb-8 md:mb-12">
              <p className="text-[10px] md:text-xs font-black uppercase text-green-700 tracking-widest mb-3 md:mb-4">Official Announcement</p>
              <h2 className="text-lg md:text-2xl font-bold text-black leading-relaxed italic border-l-4 border-yellow-400 pl-4 md:pl-8 mb-6 md:mb-8">
                Dear Valued Customer,
              </h2>
              <p className="text-gray-600 text-base md:text-xl font-medium leading-relaxed">
                {post.description ||
                  `In compliance with the Nigerian Electricity Regulatory Commission (NERC)'s directive on the deregulation of meter prices under the Meter Asset Provider (MAP) Scheme, please be informed of the revised prices for Single-Phase and Three-Phase meters, inclusive of VAT.`}
              </p>
            </div>

            {/* Table / Mobile Stack Card Area */}
            <div className="bg-gray-50  sm:p-4 md:p-10 rounded-[1.5rem] md:rounded-[2.5rem] border border-gray-100 mb-8 md:mb-12 shadow-sm">
              <div className="bg-white rounded-[1rem] md:rounded-[2rem] shadow-xl overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="w-full border-spacing-0 block md:table">
                    <thead className="hidden md:table-header-group">
                      <tr className="bg-black text-white text-[10px] font-black uppercase tracking-[0.2em]">
                        {tableHeaders.map((header) => (
                          <th
                            key={header}
                            className="px-6 py-6 text-left border-r border-white/10 last:border-none"
                          >
                            {header}
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody className="divide-y divide-gray-100 md:divide-gray-50 block md:table-row-group">
                      {displayRows.map((row, index) => (
                        <tr 
                          key={index} 
                          className="group hover:bg-green-50 transition-colors block md:table-row p-4 sm:p-6 md:p-0 space-y-3 md:space-y-0"
                        >
                          {tableHeaders.map((header, i) => (
                            <td
                              key={i}
                              className="px-0 md:px-6 py-0 md:py-5 text-sm font-bold text-gray-700 md:border-r border-gray-100 last:border-none group-hover:text-black transition-colors block md:table-cell flex justify-between items-center md:justify-start"
                            >
                              {/* Responsive label indicator for mobile screen view */}
                              <span className="md:hidden text-[10px] font-black uppercase tracking-wider text-gray-400 mr-4">
                                {header}:
                              </span>
                              <span className="text-right md:text-left ">
                                {row[header] || "-"}
                              </span>
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Validity & Closure */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 items-end border-t border-gray-100 pt-8 md:pt-12">
              <div className="text-center md:text-left">
                <div className="inline-block bg-yellow-400 text-black px-5 py-2.5 rounded-xl md:rounded-2xl font-black uppercase tracking-widest text-[9px] md:text-[10px] shadow-lg mb-4 md:mb-6">
                  Price Validity
                </div>
                <p className="text-lg md:text-xl text-black font-black uppercase tracking-tight mb-2 md:mb-4">
                  Effective From: {post.validity || "N/A"}
                </p>
                <p className="text-sm text-gray-500 font-medium italic">Thank you for your continued cooperation.</p>
              </div>

              <div className="text-center md:text-right">
                <div className="w-16 h-1 bg-green-700 mx-auto md:ml-auto mb-4 md:mb-6 rounded-full"></div>
                <p className="text-[10px] font-black uppercase text-gray-400 tracking-widest mb-1">Signed</p>
                <p className="text-xl md:text-2xl font-black text-black uppercase tracking-tighter">Management</p>
                <p className="text-[9px] md:text-[10px] font-black uppercase text-green-700 tracking-widest mt-1 md:text-right">BEDC Electricity PLC</p>
              </div>
            </div>
          </div>
        </div>

        {/* Action Callout Container */}
        <div className="mt-12 md:mt-20 p-6 sm:p-12 bg-black text-white rounded-[2rem] md:rounded-[3rem] shadow-2xl flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-10">
          <div className="text-center lg:text-left">
            <h4 className="text-xl md:text-2xl font-black uppercase tracking-tight mb-2">Ready to order?</h4>
            <p className="text-sm md:text-base font-medium opacity-60">Complete your meter acquisition through the MAP portal.</p>
          </div>
          <a href="https://imaap.beninelectric.com" className="w-full sm:w-auto">
            <button className="w-full sm:w-auto bg-yellow-400 text-black px-8 md:px-10 py-4 md:py-5 rounded-xl md:rounded-2xl font-black uppercase tracking-widest text-xs hover:bg-green-700 hover:text-white transition-all shadow-xl">
              Order Meter Now →
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default MeterPriceView;